import React from 'react';
import { render, screen } from '@testing-library/react';
import LoadingSpinner from './LoadingSpinner';

describe('LoadingSpinner', () => {
  it('renders the spinner', () => {
    const { container } = render(<LoadingSpinner />);
    expect(container.querySelector('.spinner')).toBeInTheDocument();
  });

  it('applies custom className', () => {
    const { container } = render(<LoadingSpinner className="custom" />);
    expect(container.firstChild).toHaveClass('custom');
  });

  describe('sizes', () => {
    const sizes = ['small', 'medium', 'large'] as const;

    sizes.forEach(size => {
      it(`renders ${size} size`, () => {
        const { container } = render(<LoadingSpinner size={size} />);
        expect(container.querySelector(`.${size}`)).toBeInTheDocument();
      });
    });
  });

  describe('contexts', () => {
    const contexts = ['talent', 'company', 'neutral'] as const;

    contexts.forEach(context => {
      it(`renders ${context} context`, () => {
        const { container } = render(<LoadingSpinner context={context} />);
        expect(container.querySelector(`.${context}`)).toBeInTheDocument();
      });
    });

    it('defaults to neutral context', () => {
      const { container } = render(<LoadingSpinner />);
      expect(container.querySelector('.neutral')).toBeInTheDocument();
    });
  });

  describe('accessibility', () => {
    it('has role="status"', () => {
      render(<LoadingSpinner />);
      expect(screen.getByRole('status')).toBeInTheDocument();
    });

    it('has default aria-label', () => {
      render(<LoadingSpinner />);
      expect(screen.getByRole('status')).toHaveAttribute('aria-label', 'Loading');
    });

    it('supports custom aria-label', () => {
      render(<LoadingSpinner label="Uploading document" />);
      expect(screen.getByRole('status')).toHaveAttribute('aria-label', 'Uploading document');
    });

    it('hides the visual spinner from screen readers', () => {
      const { container } = render(<LoadingSpinner />);
      expect(container.querySelector('.spinner')).toHaveAttribute('aria-hidden', 'true');
    });
  });
});
